


























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import moment from "moment";
import * as api from "@/lib/api";
import logger from "@/configs/logger";
import { firestore } from "@/configs/firebase";

@Component
export default class CommissionView extends Vue {
  @Action("getUserCommssions") getUserCommssions!: Function;
  @Action("getUserCommssionsByStatus") getUserCommssionsByStatus!: Function;
  @Action("getUserCommssionsByDateRange")
  getUserCommssionsByDateRange!: Function;
  @Prop() email!: string;

  loading = false;
  filterStatus = "";
  filterBy = "";
  filterDateRange = [];
  filterItems = ["Sale Time", "Status"];
  statusItems = ["failed", "sale", "active", "post_date"];
  sum = 0;
  commissions = [];
  headers = [
    { text: "Sale Time", value: "saleTime", filterable: true },
    { text: "Lead Name", value: "leadName", filterable: false },
    { text: "Product Name", value: "productName", filterable: false },
    { text: "Status", value: "status", filterable: true },
    { text: "Premium", value: "premium", filterable: false },
    { text: "Commission", value: "commission", filterable: false },
    { text: "Enrollment Fee", value: "enrollmentFee", filterable: false },
    { text: "Last Updated", value: "lastUpdated", filterable: false },
    { text: "Post Date", value: "postDate", filterable: false }
  ];

  get filterDateRangeText() {
    return this.filterDateRange.join(" ~ ");
  }

  @Watch("email")
  onEmailChange(val: string, preVal: string) {
    if (val && val !== preVal) {
      this.loadCommissions();
    }
  }

  @Watch("filterStatus")
  onFilterStatusChange(val: string) {
    this.loadCommissions();
  }

  @Watch("filterBy")
  onFilterByChange(val: string, prev: string) {
    // realod when filterby is cleared
    if (prev && !val) {
      this.loadCommissions();
    }
  }

  @Watch("filterDateRange")
  onFilterDateRangeChange(val: string[]) {
    if (Array.isArray(val) && val.length === 2) {
      this.loadCommissions();
    }
  }

  created() {
    if (this.email) {
      this.loadCommissions();
    }
  }

  getFilteredItems(items: any[]) {
    this.sum = 0;
    items.map(item => {
      this.sum += Number(item.commission);
      this.sum = Number(this.sum.toFixed(2));
    });
  }

  selectFilterType(val: string) {
    this.filterDateRange = [];
    this.filterStatus = "";
    this.filterBy = val;
  }

  selectFilterStatus(val: string) {
    this.filterStatus = val;
  }

  async loadCommissions() {
    this.loading = true;
    let res;
    if (this.filterBy === this.filterItems[0]) {
      if (this.filterDateRange[0] && this.filterDateRange[1]) {
        res = await this.getUserCommssionsByDateRange({
          email: this.email,
          start: firestore.Timestamp.fromDate(
            new Date(this.filterDateRange[0])
          ),
          end: firestore.Timestamp.fromDate(new Date(this.filterDateRange[1]))
        });
        logger("log", res);
      }
    } else if (this.filterBy === this.filterItems[1]) {
      res = await this.getUserCommssionsByStatus({
        email: this.email,
        status: this.filterStatus
      });
    } else {
      res = await this.getUserCommssions(this.email);
    }

    this.commissions = res.map((item: any) => ({
      saleTime: this.formatTime(item.sale_ts),
      leadName: item.lead_name,
      productName: item.name,
      status: item.status,
      premium: item.premium,
      commission: item.commission,
      enrollmentFee: item.enrollment_fee,
      lastUpdated: this.formatTime(item[`${item.status}_ts`]),
      postDate: item.post_date
    }));
    this.loading = false;
  }

  formatTime(time: any) {
    return time
      ? moment
          .unix(time.seconds)
          .local()
          .format("YYYY-MM-DD")
      : "";
  }
}
